<template>
  <el-dialog
    title="归属详情"
    top="70px"
    :modal="false"
    :visible.sync="guishuVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <div style="padding-bottom:10px">
      <span style="margin-right:10px"> 归属人：<b style="color:#c83c23">{{ radish.归属人 }}</b></span>
      <span style="margin-right:10px"> 职能模块负责人：<b>{{ fuzeren }}</b></span>
      <span> 上传人：<b>{{ radish.上传人 }}</b></span>
    </div>
    <el-table
      :data="guishuLogs"
      size="mini"
      style="width: 100%">
      <el-table-column
        prop="type"
        label="标签"
        width="150px">
      </el-table-column>
      <el-table-column
        prop="account"
        label="操作人"
        width="150px">
      </el-table-column>
      <el-table-column
        prop="operation"
        label="操作"
        width="80px">
      </el-table-column>
      <el-table-column
        prop="info"
        label="内容"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="createdAt"
        label="时间"
        width="100px">
      </el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>
const dateFormat = require('dateformat')

export default {
  data() {
    return {
      guishuLogs: [],
      guishuVisible: false,
      operationMap: {
        insert: '新增',
        update: '修改',
        delete: '删除',
      },
      fuzeren: '',
      radish: {}
    }
  },
  methods: {
    async open(radish) {
      this.radish = radish
      this.guishuLogs = []
      if (this.radish.职能模块 && this.radish.职能模块.length > 0) {
        let fuzerens = []
        this.radish.职能模块.forEach(cate => {
          const matchCate = app.categories.find(c=>c.名称 == cate)
          if (matchCate && matchCate.负责人) {
            fuzerens = fuzerens.concat(matchCate.负责人)
          }
        })
        this.fuzeren = fuzerens.toString()
      } else {
        this.fuzeren = ''
      }
      const res = await app.service('radish').getGuishuRadishFieldLogs({rid: this.radish._id})
      if (res.status == 'success') {
        this.guishuLogs = res.data.map(guishu=>{
          guishu.operation = this.operationMap[guishu.operation] || '新增'
          guishu.createdAt = dateFormat(guishu.createdAt, 'yyyy-mm-dd')
          return guishu
        })
        this.guishuVisible = true
      }
    }
  }
}
</script>
